import { install } from '@/util/utils';
import Module from './Dialog';
import ElDialog from './ElDialog';

export default install(Module, { ElDialog });
